import { render } from "./AustraliaPage.vue?vue&type=template&id=5eb0e456&scoped=true"
const script = {}

import "./AustraliaPage.vue?vue&type=style&index=0&id=5eb0e456&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5eb0e456"]])

export default __exports__